import API from '../api';
import type { CreateUserRequest, UpdateUserRequest, UserResponse } from '@paladin-monorepo/common';

export const usersApi = {
  // Account Admin endpoints (manage own account's users)
  async list(): Promise<UserResponse[]> {
    return API.get<UserResponse[]>('/users').then((res) => res.data);
  },

  async get(userId: string): Promise<UserResponse> {
    return API.get<UserResponse>(`/users/${userId}`).then((res) => res.data);
  },

  async create(data: CreateUserRequest): Promise<UserResponse> {
    return API.post<UserResponse>('/users', data).then((res) => res.data);
  },

  async update(userId: string, data: UpdateUserRequest): Promise<UserResponse> {
    return API.patch<UserResponse>(`/users/${userId}`, data).then((res) => res.data);
  },

  async removeAccountUser(userId: string): Promise<{ success: boolean }> {
    return API.delete<{ success: boolean }>(`/users/${userId}`).then(
      (res) => res.data
    );
  },

  async blockAccountUser(userId: string): Promise<{ success: boolean }> {
    return API.patch<{ success: boolean }>(`/users/${userId}/account-block`).then(
      (res) => res.data
    );
  },

  async unblockAccountUser(userId: string): Promise<{ success: boolean }> {
    return API.patch<{ success: boolean }>(`/users/${userId}/account-unblock`).then(
      (res) => res.data
    );
  },

  // Super Admin endpoints (manage all users)
  async blockUser(userId: string): Promise<{ success: boolean }> {
    return API.patch<{ success: boolean }>(`/users/${userId}/block`).then(
      (res) => res.data
    );
  },

  async unblockUser(userId: string): Promise<{ success: boolean }> {
    return API.patch<{ success: boolean }>(`/users/${userId}/unblock`).then(
      (res) => res.data
    );
  },

  async verifyEmail(userId: string): Promise<{ success: boolean }> {
    return API.patch<{ success: boolean }>(`/users/${userId}/verify-email`).then(
      (res) => res.data
    );
  },

  async verifyMembership(userId: string, membershipId: string): Promise<{ success: boolean }> {
    return API.patch<{ success: boolean }>(`/users/${userId}/verify-membership/${membershipId}`).then(
      (res) => res.data
    );
  },
};
